class ClickAndCollect {
    constructor(e) {
        (this.settings = e),
            (this.element = document.getElementById("cnc-container")),
            (this.resultsContainer = document.getElementById("cnc-results-container")),
            (this.mapContainer = document.getElementById("cnc-map-container")),
            (this.messages = {}),
            (this.mapFocus = null),
            this.settings.enableMap && window.mapIsReady && this.mapReady();
    }
    addMessage(e, t, s) {
        if (!this.messages[e]) {
            var a = new Message(t, s);
            (this.messages[e] = a), this.resultsContainer.appendChild(a.getElement());
        }
    }
    removeMessage(e) {
        this.messages[e] && ((this.messages[e].getElement().outerHTML = ""), delete this.messages[e]);
    }
    clearErrors() {
        for (let [e, t] of Object.entries(this.messages)) t.isError && this.removeMessage(e);
    }
    addAddressSearch() {
        (this.search = new AddressSearch(this)), this.mapContainer.appendChild(this.search.getElement());
    }
    addMap() {
        (this.gmap = new GMap(this)), this.mapContainer.appendChild(this.gmap.getElement()), this.gmap.initMap();
    }
    mapReady() {
        this.addAddressSearch(), this.addMap();
    }
    searchAddress(e) {
        var t = new google.maps.Geocoder(),
            s = this;
        t.geocode({ address: e }, function (t, a) {
            a == google.maps.GeocoderStatus.OK
                ? (s.removeMessage("addressNotFound"), (s.mapFocus = t[0].geometry.location), s.results.setLocation(s.mapFocus.lat(), s.mapFocus.lng()), s.results.update(), s.gmap.show())
                : (s.results.setLocation(null, null), s.addMessage("addressNotFound", e + " not found.", !0));
        });
    }
    updateMap() {
        this.gmap.searchLocationsNear(this.mapFocus, this.results.getAllOutlets());
    }
}
class ClickAndCollectCart extends ClickAndCollect {
    constructor(e) {
        super(e),
            (this.mode = null),
            (this.modeButtons = {}),
            (this.outletContactFields = {}),
            this.addModeButtons(["home", "store"]),
            this.addOutletContactFields(["address1", "address2", "address3", "suburb", "state", "postcode", "phone", "email"]),
            this.addOutletNameField(),
            this.addOutletNumberField(),
            this.addResults(),
            this.addCartUpdateListener(),
            this.setMode("home"),
            this.updateCollectionAbility(),
            this.settings.enableMap || this.results.update();
    }
    addModeButtons(e) {
        for (var t of e) {
            var s = new ModeButton(this, t);
            (this.modeButtons[t] = s), this.element.appendChild(s.getElement()), this.element.appendChild(s.getLabel());
        }
        var a = document.createElement("input");
        (a.id = "cnc-mode-input"), (a.type = "hidden"), (a.name = "attributes[cnc-fulfilment-method]"), (a.value = "home"), this.element.appendChild(a), (this.modeInput = a);
    }
    addOutletContactFields(e) {
        for (var t of e) {
            var s = new OutletContactField(t);
            (this.outletContactFields[t] = s), this.element.appendChild(s.getElement());
        }
    }
    addOutletNumberField() {
        var e = new OutletContactField("number", "cnc-outlet", "attributes[cnc-outlet]");
        (this.outletNumberField = e), this.element.appendChild(e.getElement());
    }
    addOutletNameField() {
        var e = new OutletContactField("name", "cnc-store-name", "attributes[cnc-store-name]");
        (this.outletNameField = e), this.element.appendChild(e.getElement());
    }
    addResults() {
        (this.results = new CartResults(this, this.settings.apiPrefix, this.settings.subdomain)), this.resultsContainer.appendChild(this.results.getElement());
    }
    getMode() {
        return this.mode;
    }
    setMode(e) {
        if (e !== this.mode) {
            this.clearErrors(), (this.mode = e), (this.modeInput.value = e);
            for (let [t, s] of Object.entries(this.modeButtons)) s.getValue() === e && s.select(), s.updateDisplay();
            if ("home" === this.mode) {
                this.mapContainer && (this.mapContainer.style.display = "none"), this.results.hide(), this.results.selectNone();
                for (let [e, t] of Object.entries(this.outletContactFields)) t.clear();
                // this.outletNameField.clear(), this.addMessage("home", "You will be able to select a home delivery method in the checkout.", !1);
            } else "store" === this.mode && (this.mapContainer && (this.mapContainer.style.display = ""), this.results.show(), this.removeMessage("home"), this.results.selectFirst(), this.updateContactFields());
            this.updateCheckoutButton();
        }
    }
    updateCollectionAbility() {
        this.results.doOutletsExist() || this.settings.enableMap
            ? (this.modeButtons.store.show(), this.removeMessage("noLocations"))
            : (this.setMode("home"), this.modeButtons.store.hide(), this.addMessage("noLocations", "No locations available for store pickup.", !0));
    }
    updateContactFields() {
        var e = this.results.getSelectedOutlet();
        if (e) {
            for (let [t, s] of Object.entries(this.outletContactFields)) s.setValue(e.getContact()[t]);
            this.outletNameField.setValue(e.getName()), this.outletNumberField.setValue(e.getExternalId());
        }
    }
    updateCheckoutButton() {
        var e = document.querySelector('button[name="checkout"]') || document.querySelector('input[name="checkout"]');
        e &&
            ((this.checkoutButton = e),
            "store" !== this.mode || this.results.areOutletsAvailable()
                ? ((e.disabled = !1), this.removeMessage("pleaseUpdateCart"), this.removeMessage("pleaseSearchAgain"))
                : ((e.disabled = !0),
                  this.results.isLoaded() &&
                      (this.settings.enableMap && this.results.count() < 1
                          ? (this.removeMessage("pleaseUpdateCart"), this.addMessage("pleaseSearchAgain", "Sorry, no pickup locations are available in this area. Please search again or choose Home Delivery.", !0))
                          : (this.removeMessage("pleaseSearchAgain"),
                            this.addMessage("pleaseUpdateCart", "", !0)))));
    }
    addCartUpdateListener() {
        var e = this,
            t = document.getElementById("CartProducts");
        t &&
            t.addEventListener("DOMSubtreeModified", (t) => {
                e.results.isLoaded() && e.results.update();
            });
    }
}
class ClickAndCollectProduct extends ClickAndCollect {
    constructor(e, t) {
        super(e), (this.initialVariantId = t), this.addCheckStockButton(), this.addResults(), this.addVariantEventListener(), this.mapContainer && (this.mapContainer.style.display = "block");
    }
    addCheckStockButton() {
        var e = new CheckStockButton(this);
        this.element.appendChild(e.getElement());
    }
    addResults() {
        var e = new ProductResults(this, this.settings.apiPrefix, this.settings.subdomain, this.initialVariantId);
        (this.results = e), this.resultsContainer.appendChild(this.results.getElement());
    }
    addVariantEventListener() {
        var e = document.querySelector('form[action="/cart/add"]');
        e &&
            e.addEventListener("click", (e) => {
                this.results.isLoaded() && (this.results.unload(), this.clearErrors(), this.settings.enableMap && ((this.mapContainer.style.display = "none"), this.gmap.hide()));
            });
    }
    reveal() {
        this.settings.enableMap ? (this.mapContainer.style.display = "") : this.results.fetch();
    }
    resultsLoaded() {
        this.settings.enableMap && this.results.count() < 1 ? this.addMessage("pleaseSearchAgain", "Sorry, no pickup locations are available in this area.", !0) : this.removeMessage("pleaseSearchAgain");
    }
}
class Renderable {
    getElement() {
        return this.element;
    }
    show() {
        (this.element.style.display = ""), this.label && (this.label.style.display = "");
    }
    hide() {
        (this.element.style.display = "none"), this.label && (this.label.style.display = "none");
    }
}
class AddressSearch extends Renderable {
    constructor(e) {
        super(), (this.cnc = e), this.createElement();
    }
    createElement() {
        (this.element = document.createElement("div")),
            this.element.classList.add("cnc-address-search"),
            (this.element.id = "cnc-address-search"),
            (this.label = document.createElement("p")),
            this.element.appendChild(this.label),
            (this.input = document.createElement("input")),
            (this.input.type = "text"),
            this.input.classList.add("cnc-address-search-input", "input__field"),
            (this.input.placeholder = "Enter postcode, suburb or state"),
            this.element.appendChild(this.input),
            (this.button = document.createElement("button")),
            (this.button.type = "button"),
            this.button.classList.add("cnc-address-search-button", "form__submit", "button", "button--primary"),
            (this.button.innerHTML = "<span>Search</span>"),
            this.element.appendChild(this.button),
            this.button.addEventListener("click", (e) => {
                this.cnc.searchAddress(this.input.value);
            });
        var e = this;
        this.input.addEventListener("keyup", function (t) {
            if (13 === t.keyCode) return t.preventDefault(), e.button.click(), !1;
        }),
            this.input.addEventListener("keydown", function (e) {
                if (13 === e.keyCode) return e.preventDefault(), !1;
            });
    }
}
class GMap extends Renderable {
    constructor(e) {
        super(), (this.cnc = e), this.gmap, (this.markers = []), this.infoWindow, this.locationSelect, (this.mapInitialised = !1), this.createElement();
    }
    createElement() {
        (this.element = document.createElement("div")), (this.element.id = "cnc-map"), this.hide();
    }
    initMap() {
        (this.gmap = new google.maps.Map(this.element, { center: { lat: -33.863276, lng: 151.107977 }, zoom: 11, zoomControl: !0, mapTypeId: "roadmap" })), (this.infoWindow = new google.maps.InfoWindow()), (this.mapInitialised = !0);
    }
    clearLocations() {
        this.infoWindow.close();
        for (var e = 0; e < this.markers.length; e++) this.markers[e].setMap(null);
        this.markers.length = 0;
    }
    searchLocationsNear(e, t) {
        this.clearLocations();
        var s = new google.maps.LatLngBounds();
        for (let [e, n] of Object.entries(t)) {
            s = new google.maps.LatLngBounds();
            var a = n.getAddressHtml(),
                i = new google.maps.LatLng(parseFloat(n.getContact().latitude), parseFloat(n.getContact().longitude));
            this.createMarker(i, e, a, n.data.distance), s.extend(i);
        }
        if (t.length >= 1) {
            this.gmap.fitBounds(s);
            var n = this.gmap.getZoom();
            this.gmap.setZoom(n > 10 ? 10 : n);
        } else this.gmap.setCenter(e);
    }
    createMarker(e, t, s, a) {
        var i = `<b>${t}</b><br>`;
        a && (i += a + "km<br>"), (i += s);
        var n = new google.maps.Marker({ map: this.gmap, position: e }),
            l = this;
        google.maps.event.addListener(n, "click", function () {
            l.infoWindow.setContent(i), l.infoWindow.open(l.gmap, n);
        }),
            this.markers.push(n);
    }
}
class ModeButton extends Renderable {
    constructor(e, t) {
        super(),
            (this.cnc = e),
            (this.value = t),
            this.createElement(),
            this.createLabel(),
            this.element.addEventListener("change", (e) => {
                this.cnc.setMode(this.element.value);
            }),
            this.updateDisplay();
    }
    select() {
        this.element.checked || (this.element.checked = !0);
    }
    updateDisplay() {
        this.element.checked ? this.label.classList.add("button--primary") && this.label.classList.remove("button--secondary") : this.label.classList.remove("button--primary") && this.label.classList.add("button--secondary");
    }
    createElement() {
    
        (this.element = document.createElement("input")), (this.element.id = `cnc-${this.value}-radio`), (this.element.type = "radio"), (this.element.value = this.value), (this.element.name = "cnc-mode-radio");
    }
    createLabel() {
        (this.label = document.createElement("label")),
    
        this.label.setAttribute("for", `cnc-${this.value}-radio`),
        this.label.classList.add("button"),
        "home" === this.value ? (this.label.innerHTML = '<div class="radio-wrap"><span class="label-icon"></span><span class="label-name heading-xs">Home Delivery <br/> <span class="p2">Free standard delivery + Free express over $300</span></span></div>') : "store" === this.value && ((this.label.style.display = "none"), (this.label.innerHTML = `<div class="radio-wrap"><span class="label-icon"></span><span class="label-name heading-xs"><span class="location-label">Store Pickup</span> <br/> <span class="p2" style="text-decoration: underline;">Click to change store</span></span></div>`));

        $('.cnc-address-search-button').click(function(){
            setTimeout(function() {
                var location = $('#cnc-store-name').val();
                if (location == 'Warehouse') {
                    $('.location-label').text('Collect from '+location);
                } else {
                    $('.location-label').text('Collect from '+location+' Store');
                }
            }, 2000);
        });

        $('input[type=radio][name=cnc-outlet-element]').change(function() {
            var location = $('#cnc-store-name').val();
            if (location == 'Warehouse') {
                $('.location-label').text('Collect from '+location);
            } else {
                $('.location-label').text('Collect from '+location+' Store');
            }
        });

    }
    getLabel() {
        return this.label;
    }
    getValue() {
        return this.element.value;
    }
    
}
class CheckStockButton extends Renderable {
    constructor(e) {
        super(),
            (this.cncProduct = e),
            this.createElement(),
            this.element.addEventListener("click", (e) => {
                var t = document.querySelector('form[action="/cart/add"] button[type="submit"]');
                t && t.disabled ? this.cncProduct.addMessage("productUnavailable", "Product variant is unavailable.", !0) : (this.cncProduct.removeMessage("productUnavailable"), this.cncProduct.reveal());
            });
    }
    createElement() {
        (this.element = document.createElement("button")), (this.element.innerHTML = "Search"), this.element.classList.add("button--primary"), (this.element.style.display = "none");
    }
}
class Outlet extends Renderable {
    constructor(e, t, s) {
        super(),
            (this.cnc = e),
            (this.data = t),
            this.createAvailabilityTable(s),
            this.createElement(),
            this.createLabel(),
            this.element.addEventListener("change", (t) => {
                e.updateContactFields();
            });           
    }
    getAvailability() {
        return this.availabilityTable && this.availabilityTable.isOutletAvailable();
    }
    getAvailabilityTable() {
        return this.availabilityTable;
    }
    createAvailabilityTable(e) {
        this.availabilityTable = new AvailabilityTable(e, this.data.stock, !0, this.cnc.settings.showQuantity);
    }
    isSelected() {
        return this.element.checked;
    }
    select() {
        this.element.checked = !0;
    }
    deselect() {
        this.element.checked = !1;
    }
    getContact() {
        return this.data.contact;
    }
    getName() {
        return this.data.name;
    }
    getExternalId() {
        return this.data.external_id;
    }
    createElement() {
        (this.element = document.createElement("input"));
            (this.element.id = `cnc-outlet-${this.data.external_id}`);
            (this.element.type = "radio");
            (this.element.name = "cnc-outlet-element");
            (this.element.value = this.data.external_id);
            // (this.element.disabled = !this.getAvailability()),
            this.element.classList.add("cnc-outlet");
    }

    createLabel() {
        (this.label = document.createElement("label")), this.label.setAttribute("for", `cnc-outlet-${this.data.external_id}`), this.label.classList.add("cnc-outlet-label");
        var e = document.createElement("div");
        var queens_plaza_boutique = (this.data.name == 'Queens Plaza Boutique') ? "<p>Monday: 10:00am-5:30pm</p><p>Tuesday: 10:00am-5:30pm</p><p>Wednesday:<strong> </strong>10:00am-5:30pm</p><p>Thursday: 10:00am-5:30pm</p><p>Friday: 10:00am-5:30pm</p><p>Saturday: 10:00am-5:00pm</p><p>Sunday: 11:00am-3:00pm</p>":"";
        var carindale_boutique = (this.data.name == 'Carindale Boutique') ? "<p>Monday: 9:00am-5:30pm</p><p>Tuesday: 9:00am-5:30pm</p><p>Wednesday: 9:00am-5:30pm</p><p>Thursday: 9:00am-8:00pm</p><p>Friday:  9:00am-5:30pm</p><p>Saturday: 9:00am-5:00pm</p><p>Sunday: 10:00am-4:00pm</p>":""; 
        var chermside_boutique = (this.data.name == 'Chermside Boutique') ? "<p>Monday: 9:00am-5:30pm</p><p>Tuesday: 9:00am-5:30pm</p><p>Wednesday: 9:00am-5:30pm</p><p>Thursday: 9:00am-8:00pm</p><p>Friday:  9:00am-5:30pm</p><p>Saturday: 9:00am-5:00pm</p><p>Sunday: 10:00am-4:00pm</p>":""; 

        e.classList.add("cnc-store-details"),
            e.insertAdjacentHTML("beforeend", `<strong class="location-name">${this.data.name}</strong><br>`),
            this.data.distance && e.insertAdjacentHTML("beforeend", this.data.distance + "km<br>"),
            e.insertAdjacentHTML("beforeend", this.getAddressHtml()),
            e.insertAdjacentHTML("beforeend", `<div class="opening-hours p3">${queens_plaza_boutique}</div>`),
            e.insertAdjacentHTML("beforeend", `<div class="opening-hours p3">${carindale_boutique}</div>`),
            e.insertAdjacentHTML("beforeend", `<div class="opening-hours p3">${chermside_boutique}</div>`),
            this.label.appendChild(e),
            this.label.appendChild(this.getAvailabilityTable().getElement());
            $('.cnc-availability-table').append('<div>hello</div>');  
    }

    getAddressHtml() {
        document.createElement("span").id = `cnc-outlet-${this.data.external_id}-address`;
        var e = "";
        return (
            this.data.contact.address1 && (e += this.data.contact.address1 + "<br>"),
            this.data.contact.address2 && (e += this.data.contact.address2 + "<br>"),
            this.data.contact.address3 && (e += this.data.contact.address3 + "<br>"),
            this.data.contact.suburb && (e += this.data.contact.suburb + " "),
            this.data.contact.state && (e += this.data.contact.state + " "),
            this.data.contact.postcode && (e += this.data.contact.postcode),
            (e += "<br>"),
            this.data.contact.phone && (e += `<span class="phone"><a href="tel:${this.data.contact.phone}">${this.data.contact.phone}</a></span><br>`),
            this.data.contact.email && (e += `<span class="email"><a href="mailto:${this.data.contact.email}">${this.data.contact.email}</a></span>`),
            e
        );
    }

    getLabel() {
        return this.label;
    }
}
class ProductOutlet extends Outlet {
    constructor(e, t, s) {
        super(e, t, s);
    }
    createAvailabilityTable(e) {
        this.availabilityTable = new AvailabilityTable(e, this.data.stock, !1, this.cnc.settings.showQuantity);
    }
    createElement() {
        (this.element = document.createElement("div")), this.element.classList.add("cnc-outlet");
    }

    createLabel() {
        (this.label = document.createElement("label")), this.label.setAttribute("for", `cnc-outlet-${this.data.external_id}`), this.label.classList.add("cnc-outlet-label");
        var e = document.createElement("div");
        var queens_plaza_boutique = (this.data.name == 'Queens Plaza Boutique') ? "<p>Monday: 10:00am-5:30pm</p><p>Tuesday: 10:00am-5:30pm</p><p>Wednesday:<strong> </strong>10:00am-5:30pm</p><p>Thursday: 10:00am-5:30pm</p><p>Friday: 10:00am-5:30pm</p><p>Saturday: 10:00am-5:00pm</p><p>Sunday: 11:00am-3:00pm</p>":"";
        var carindale_boutique = (this.data.name == 'Carindale Boutique') ? "<p>Monday: 9:00am-5:30pm</p><p>Tuesday: 9:00am-5:30pm</p><p>Wednesday: 9:00am-5:30pm</p><p>Thursday: 9:00am-8:00pm</p><p>Friday:  9:00am-5:30pm</p><p>Saturday: 9:00am-5:00pm</p><p>Sunday: 10:00am-4:00pm</p>":""; 
        var chermside_boutique = (this.data.name == 'Chermside Boutique') ? "<p>Monday: 9:00am-5:30pm</p><p>Tuesday: 9:00am-5:30pm</p><p>Wednesday: 9:00am-5:30pm</p><p>Thursday: 9:00am-8:00pm</p><p>Friday:  9:00am-5:30pm</p><p>Saturday: 9:00am-5:00pm</p><p>Sunday: 10:00am-4:00pm</p>":""; 
        

        e.classList.add("cnc-store-details"),
            e.insertAdjacentHTML("beforeend", `<strong class="location-name">${this.data.name}</strong><br>`),
            this.data.distance && e.insertAdjacentHTML("beforeend", this.data.distance + "km<br>"),
            e.insertAdjacentHTML("beforeend", this.getAddressHtml()),
            e.insertAdjacentHTML("beforeend", `<div class="opening-hours p3">${queens_plaza_boutique}</div>`),
            e.insertAdjacentHTML("beforeend", `<div class="opening-hours p3">${carindale_boutique}</div>`),
            e.insertAdjacentHTML("beforeend", `<div class="opening-hours p3">${chermside_boutique}</div>`),
            this.label.appendChild(e),
            this.label.appendChild(this.getAvailabilityTable().getElement());
            $('.cnc-availability-table').append('<div>hello</div>');  
    }

}
class AvailabilityTable extends Renderable {
    constructor(e, t, s, a) {
        super(), (this.products = []), (this.showTable = s), (this.showQuantity = a), this.updateProducts(e, t), this.createElement();
    }
    updateProducts(e, t) {
        if (e && e.length)
            for (let a of e) {
                ((s = Object.assign({}, a)).outletStock = t[a.variant_id]), this.products.push(s);
            }
        else
            for (let [e, a] of Object.entries(t)) {
                var s = { variant_id: e, outletStock: a, quantity: 1 };
                this.products.push(s);
            }
    }
    isOutletAvailable() {
        for (let e of this.products) if (!this.isProductAvailable(e)) return !1;
        return !0;
    }
    isProductAvailable(e) {
        return e.outletStock >= e.quantity;
    }
    createElement() {
        this.showTable ? this.createTableElement() : this.createTextElement();
    }
    createTableElement() {
    
        if (((this.element = document.createElement("table")), this.element.classList.add("cnc-availability-table"), this.isOutletAvailable())) var e = `<div class="stock-message"><span class="instock"><svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.3327 1.87839L4.90976 9.28945L0.666016 5.0457L1.927 3.78471L4.81648 6.67419L9.98506 0.710449L11.3327 1.87839Z" fill="#219653"/>
        </svg> All items available</span></div>`;
        else e = `<div class="stock-message"><span class="lowstock"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.00912 3.31157C7.45765 2.45148 8.54105 2.45148 8.98957 3.31157L13.1663 11.3209C13.6281 12.2065 13.0737 13.3332 12.1761 13.3332H3.82259C2.92498 13.3332 2.37055 12.2065 2.83236 11.3209L7.00912 3.31157ZM7.40676 8.88873V5.92576H8.59194V8.88873H7.40676ZM7.99935 11.5554C7.50843 11.5554 7.11046 11.1574 7.11046 10.6665C7.11046 10.1756 7.50843 9.77761 7.99935 9.77761C8.49027 9.77761 8.88824 10.1756 8.88824 10.6665C8.88824 11.1574 8.49027 11.5554 7.99935 11.5554Z" fill="#F2994A"/>
        </svg> Some items are not available</span> <span class="p3">Please contact the store to ensure this item is available.</span></div>`;
        var t = document.createElement("thead");
        t.insertAdjacentHTML("beforeend", e), t.insertAdjacentHTML("beforeend", "<tr><th>Product</th><th>Qty</th><th>Available</th></tr>"), this.element.appendChild(t);
        var s = document.createElement("tbody");
        for (let e of this.products) {
            if (this.isProductAvailable(e)) var a = e.title;
            else if (e.outletStock > 0) a = `<span class="strike">${e.title}</span> <span class="cnc-negative-text">(Insufficient stock)</span>`;
            else 
                a = `<span class="strike">${e.title}</span> <span class="cnc-negative-text">(Out of stock)</span>`;
            if (this.showQuantity) var i = this.isProductAvailable(e) ? `<span class="cnc-positive-text"><strong>${e.outletStock}</strong></span>` : `<span class="cnc-negative-text"><strong>${e.outletStock}</strong></span>`;
            else i = this.isProductAvailable(e) ? `<svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.3327 1.87839L4.90976 9.28945L0.666016 5.0457L1.927 3.78471L4.81648 6.67419L9.98506 0.710449L11.3327 1.87839Z" fill="#219653"/>
            </svg>` : '<span class="out-of-stock">X</span>';
            s.insertAdjacentHTML("beforeend", `<tr><td>${a}</td><td>${e.quantity}</td><td>${i}</td></tr>`);
            if (e.outletStock <= 0)
                var productTitle =  encodeURIComponent(e.title.split('-')[0]).replace(/%20/g,'-').toLowerCase();
                $('.'+productTitle+'available').html(`<div class="stock-message"><span class="lowstock"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.00912 3.31157C7.45765 2.45148 8.54105 2.45148 8.98957 3.31157L13.1663 11.3209C13.6281 12.2065 13.0737 13.3332 12.1761 13.3332H3.82259C2.92498 13.3332 2.37055 12.2065 2.83236 11.3209L7.00912 3.31157ZM7.40676 8.88873V5.92576H8.59194V8.88873H7.40676ZM7.99935 11.5554C7.50843 11.5554 7.11046 11.1574 7.11046 10.6665C7.11046 10.1756 7.50843 9.77761 7.99935 9.77761C8.49027 9.77761 8.88824 10.1756 8.88824 10.6665C8.88824 11.1574 8.49027 11.5554 7.99935 11.5554Z" fill="#F2994A"/>
                </svg> Not available for click and collect</span></div><p class="p3">Please contact the store to ensure this item is available.</p>`);
        }
        this.element.appendChild(s);
    }
   
    createTextElement() {
        if (this.products[0].outletStock >= 4) {
        (this.element = document.createElement("p")),
            this.element.classList.add("cnc-heading-availability"),
            this.isOutletAvailable()
                ? (this.showQuantity && 1 === this.products.length ? (
                    this.element.innerHTML = `<div class="stock-message"><span class="instock"><svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.3327 1.87839L4.90976 9.28945L0.666016 5.0457L1.927 3.78471L4.81648 6.67419L9.98506 0.710449L11.3327 1.87839Z" fill="#219653"/>
                    </svg> In stock - ${this.products[0].outletStock} available</span> <span class="p3">Please contact the store to ensure this item is available.</span></div>`

                    ) : (this.element.innerHTML = `<div class="stock-message"><span class="instock"><svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.3327 1.87839L4.90976 9.28945L0.666016 5.0457L1.927 3.78471L4.81648 6.67419L9.98506 0.710449L11.3327 1.87839Z" fill="#219653"/>
                    </svg> In stock</span> <span class="p3">Please contact the store to ensure this item is available.</span></div>`), this.element.classList.add("cnc-heading-available"))
                  : ((this.element.innerHTML = `<div class="stock-message"><span class="out-of-stock">X Out of stock</span> <span class="p3">Please contact the store to ensure this item is available.</span></div>`), this.element.classList.add("cnc-heading-unavailable"));
        }  else {
            (this.element = document.createElement("p")),
            this.element.classList.add("cnc-heading-availability"),
            this.isOutletAvailable() 
                ? (this.showQuantity && 1 === this.products.length ? (
                    this.element.innerHTML = `<div class="stock-message"><span class="lowstock"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.00912 3.31157C7.45765 2.45148 8.54105 2.45148 8.98957 3.31157L13.1663 11.3209C13.6281 12.2065 13.0737 13.3332 12.1761 13.3332H3.82259C2.92498 13.3332 2.37055 12.2065 2.83236 11.3209L7.00912 3.31157ZM7.40676 8.88873V5.92576H8.59194V8.88873H7.40676ZM7.99935 11.5554C7.50843 11.5554 7.11046 11.1574 7.11046 10.6665C7.11046 10.1756 7.50843 9.77761 7.99935 9.77761C8.49027 9.77761 8.88824 10.1756 8.88824 10.6665C8.88824 11.1574 8.49027 11.5554 7.99935 11.5554Z" fill="#F2994A"/>
                    </svg> Low stock - ${this.products[0].outletStock} available</span> <span class="p3">Please contact the store to ensure this item is available.</span></div>`

                    ) : (this.element.innerHTML = `<div class="stock-message"><span class="lowstock"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.00912 3.31157C7.45765 2.45148 8.54105 2.45148 8.98957 3.31157L13.1663 11.3209C13.6281 12.2065 13.0737 13.3332 12.1761 13.3332H3.82259C2.92498 13.3332 2.37055 12.2065 2.83236 11.3209L7.00912 3.31157ZM7.40676 8.88873V5.92576H8.59194V8.88873H7.40676ZM7.99935 11.5554C7.50843 11.5554 7.11046 11.1574 7.11046 10.6665C7.11046 10.1756 7.50843 9.77761 7.99935 9.77761C8.49027 9.77761 8.88824 10.1756 8.88824 10.6665C8.88824 11.1574 8.49027 11.5554 7.99935 11.5554Z" fill="#F2994A"/>
                    </svg> Low stock</span> <span class="p3">Please contact the store to ensure this item is available.</span></div>`), this.element.classList.add("cnc-heading-available"))
                  : ((this.element.innerHTML = `<div class="stock-message"><span class="out-of-stock">X Out of stock</span> <span class="p3">Please contact the store to ensure this item is available.</span></div>`), this.element.classList.add("cnc-heading-unavailable") );

        }
        
    }
    
}
class OutletContactField extends Renderable {
    constructor(e, t, s) {
        super(), (this.name = e), this.createElement(t, s);
    }
    createElement(e, t) {
        (this.element = document.createElement("input")),
            (this.element.type = "hidden"),
            this.element.classList.add("cnc-contact"),
            (this.element.id = e || `cnc-contact-${this.name}`),
            (this.element.name = t || `attributes[cnc-store-${this.name}]`),
            (this.element.value = "");
    }
    getElement() {
        return this.element;
    }
    clear() {
        this.element.value = "";
    }
    setValue(e) {
        this.element.value = e;
    }
}
class Message extends Renderable {
    constructor(e, t) {
        super(), this.createElement(), this.setValue(e), this.setIsError(t);
    }
    createElement() {
        (this.element = document.createElement("div")), (this.element.id = "cnc-message"), (this.paragraph = document.createElement("p")), this.element.appendChild(this.paragraph);
    }
    getValue() {
        return this.value;
    }
    setValue(e) {
        (this.value = e), (this.paragraph.innerHTML = e);
    }
    clear() {
        this.setValue("");
    }
    setIsError(e) {
        (this.isError = e), this.isError ? this.element.classList.add("cnc-negative-text") : this.element.classList.remove("cnc-negative-text");
    }
}
class Results extends Renderable {
    constructor(e, t, s) {
        super(), (this.cnc = e), (this.apiPrefix = t), (this.subdomain = s), (this.outlets = {}), (this.loaded = !1), (this.lastUpdate = 0);
    }
    update() {}
    fetch() {}
    createElement() {
        (this.element = document.createElement("div")), (this.element.id = "cnc-results"), (this.element.style.display = "none");
    }
    createList() {
        (this.list = document.createElement("ul")), (this.list.id = "cnc-outlets"), this.list.classList.add("cart-attribute__field"), this.element.appendChild(this.list);
    }
    setLocation(e, t) {
        (this.latitude = e), (this.longitude = t);
    }
    getAllOutlets() {
        return this.outlets;
    }
    count() {
        return Object.keys(this.outlets).length;
    }
    unload() {
        for (this.outlets = []; this.list.firstChild; ) this.list.removeChild(this.list.firstChild);
    }
    renderOutlet(e) {
        var t = document.createElement("li");
        t.appendChild(e.getElement()), t.appendChild(e.getLabel()), this.list.appendChild(t);
    }
    isLoaded() {
        return this.loaded;
    }
    doOutletsExist() {
        return Object.keys(this.outlets).length > 0;
    }
    areOutletsAvailable() {
        for (let [e, t] of Object.entries(this.outlets)) if (t.getAvailability()) return !0;
    }
}
class CartResults extends Results {
    constructor(e, t, s) {
        super(e, t, s), this.createElement(), this.createInfo(), this.createList(), (this.variantIds = []), (this.cartItems = {});
    }
    createInfo() {
        (this.info = document.createElement("p")), (this.info.id = "cnc-info"), this.element.appendChild(this.info);
    }
    setInfo(e) {
        this.info.innerHTML = e;
    }
    selectNone() {
        for (let [e, t] of Object.entries(this.outlets)) t.deselect(), this.cnc.updateContactFields();
    }
    selectFirst() {
        for (let [e, t] of Object.entries(this.outlets)) if (t.getAvailability()) return t.select(), void this.cnc.updateContactFields();
    }
    getSelectedOutlet() {
        for (let [e, t] of Object.entries(this.outlets)) if (t.isSelected()) return t;
    }
    update() {
        if (!(Date.now() - this.lastUpdate < 1e3)) {
            this.lastUpdate = Date.now();
            var e = this;
            Shopify.getCart(function (t) {
                var s = [];
                t.items.forEach(function (e) {
                    s.push(e.variant_id);
                }),
                    (e.cartItems = t.items),
                    (e.variantIds = s),
                    e.fetch();
            });
        }
    }
    fetch() {
        this.unload();
        var e = this,
            t = `https://${this.apiPrefix}/api/shopify_stores/${this.subdomain}/outlets?variant_ids=${this.variantIds.join()}`;
        for (let e of this.cartItems) t += `&qty-${e.variant_id}=${e.quantity}`;
        this.latitude && this.longitude && (t += `&latitude=${this.latitude}&longitude=${this.longitude}`),
            fetch(t)
                .then(function (e) {
                    return e.json();
                })
                .then(function (t) {
                    for (let a of t.outlets) {
                        var s = new Outlet(e.cnc, a, e.cartItems);
                        (e.outlets[s.getName()] = s), e.renderOutlet(s);
                    }
                    t.outlets.length ? e.setInfo("Please choose a pickup location:") : e.setInfo(""),
                        (e.loaded = !0),
                        e.cnc.updateCollectionAbility(),
                        e.cnc.updateCheckoutButton(),
                        e.cnc.settings.enableMap && e.cnc.updateMap(),
                        "store" === e.cnc.getMode() && e.selectFirst();
                });
    }
}
class ProductResults extends Results {
    constructor(e, t, s, a) {
        super(e, t, s), this.createElement(), this.createList(), (this.initialVariantId = a);
    }
    createElement() {
        (this.element = document.createElement("div")), (this.element.id = "cnc-results");
    }
    update() {
        this.fetch();
    }
    fetch() {
        this.unload();
        var e = this,
            t = this.findGetParameter("variant");
        t || (t = this.initialVariantId);
        var s = `https://${this.apiPrefix}/api/shopify_stores/${this.subdomain}/outlets?variant_ids=${t}&qty-${t}=1`;
        this.latitude && this.longitude && (s += `&latitude=${this.latitude}&longitude=${this.longitude}`),
            fetch(s)
                .then(function (e) {
                    return e.json();
                })
                .then(function (t) {
                    for (let a of t.outlets) {
                        var s = new ProductOutlet(e.cnc, a);
                        (e.outlets[s.getName()] = s), e.renderOutlet(s);
                    }
                    (e.loaded = !0), e.cnc.settings.enableMap && e.cnc.updateMap(), e.cnc.resultsLoaded();
                });
    }
    getSelectedVariantIdFromHtml() {
        var e = document.getElementById("ProductSelect-product-template");
        if (e) return e.options[e.selectedIndex].value;
    }
    findGetParameter(e) {
        var t = null,
            s = [];
        return (
            location.search
                .substr(1)
                .split("&")
                .forEach(function (a) {
                    (s = a.split("="))[0] === e && (t = decodeURIComponent(s[1]));
                }),
            t
        );
    }
}


